import MarkdownIt from 'markdown-it'

const mdParser = new MarkdownIt(/* Markdown-it options */);

export default mdParser